import 'inventory-listing/components/ListingFilters/Components/ListingFiltersColors/ListingFiltersColors.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { findIndex, forEach, includes, map } from 'lodash';
import { LocaleService, UrlService } from '@sm360/widget-commons-core-services';
import { AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';

import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';

import FiltersColor from 'inventory-listing/components/ListingFilters/Components/ListingFiltersColors/FiltersColor.jsx';

class ListingFiltersColors extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            colors: props.colors,
        };

        this.colorChange = this.colorChange.bind(this);
        this.resetSettings = this.resetSettings.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            colors: this.mapColors(newProps.colors),
        });
    }

    mapColors(colors) {
        const queryParamColors = UrlService.getUrlParameter('exteriorColorIds');
        const selectedColors = queryParamColors ? queryParamColors.split(',').map((id) => parseInt(id, 10)) : [];
        // Remove undefined color (with code -1) as it can be mistaken with white color
        const parsedColors = colors.filter((color) => color.code !== -1);
        return map(parsedColors, (color) => {
            return color.set('isSelected', includes(selectedColors, color.code));
        });
    }

    colorChange(code) {
        const colors = this.state.colors;
        const index = findIndex(colors, { code });

        colors[index] = colors[index].set('isSelected', !colors[index].isSelected);

        if (colors[index].isSelected) {
            AnalyticsService.ga4Trigger(TAGS.COLOURS(colors[index].label));
        }

        this.props.updateVehicleCriteria(colors, 'exteriorColorIds', colors[index].isSelected);

        this.setState({
            colors,
        });
    }

    resetSettings(event) {
        event.preventDefault();

        const colors = this.state.colors;

        forEach(colors, (color, index) => {
            colors[index] = color.set('isSelected', false);
        });

        this.props.updateVehicleCriteria(colors, 'exteriorColorIds', false);

        this.setState({
            colors,
        });
    }

    render() {
        const filterColors = this.state.colors.map((color) => (
            <FiltersColor color={color} key={color.code} handleChange={this.colorChange} />
        ));

        return (
            <div className="listing-used-filters-bloc listing-used-filters-colors">
                <div className="clearfix">
                    <div className="listing-used-filters-title sr-text is-bold">
                        {LocaleService.t('FILTERS.COLORS')}
                    </div>
                    <button onClick={this.resetSettings} className="listing-used-filters-clear is-util">
                        {LocaleService.t('BUTTONS.CLEAR')}
                    </button>
                </div>
                <ul className="clearfix">{filterColors}</ul>
            </div>
        );
    }
}

ListingFiltersColors.defaultProps = {
    colors: [],
};

ListingFiltersColors.propTypes = {
    colors: PropTypes.arrayOf(PropTypes.instanceOf(MetaDataModel)),
    updateVehicleCriteria: PropTypes.func.isRequired,
};

ListingFiltersColors.displayName = 'ListingFiltersColors';

export default ListingFiltersColors;
